/**
 * Default colors for the countdown component
 */
export const DEFAULT_COUNTDOWN_COLORS = {
    BOX_COLOR: '#ffffff',
    TEXT_COLOR: '#ff0000'
};
